import { Button } from '@consigli/facade';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaTimesCircle } from 'react-icons/fa';

interface ActionItemsErrorProps {
  error: string;
  hasTranscripts: boolean;
  onRetry: () => void;
}

export const ActionItemsError: FC<ActionItemsErrorProps> = ({ error, hasTranscripts, onRetry }) => {
  const { t } = useTranslation();

  return (
    <div className="border rounded-lg p-4 bg-red-50 border-red-200">
      <div className="flex items-start space-x-3">
        <FaTimesCircle className="text-red-500 mt-0.5 flex-shrink-0" />
        <div>
          <h3 className="font-medium text-red-800">
            {t('meeting-secretary.meetings.action-items-generation-failed')}
          </h3>
          <p className="text-sm mt-1 text-red-700">{error}</p>
          {hasTranscripts && (
            <Button error rounded onClick={onRetry} className="mt-2 !text-sm !px-3 !py-1">
              {t('meeting-secretary.meetings.try-again')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
